/**
 * @file inward-no-access.tsx
 * @module app/modules/inward/components/inward-no-access
 * @description Shown instead of an Inward screen when the user has no access to it.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.4.0
 * @version 1.4.0
 */

export const InwardNoAccess = () => (
  <div className="inward-empty" data-testid="inward-no-access">
    You do not have access to Inward. Ask an administrator to grant it in Roles
    &amp; Permissions.
  </div>
);
